import React, {useState} from 'react';
import Strings from "../Lang/strings";
import {TranslateIcon, ChevronDownIcon} from '@heroicons/react/solid'
import {availableLangs} from "../utils/constants";
import logo from "../assets/images/small-logo.png";
import zainLogo from "../assets/images/zain-logo.png";


const Header = ({setLang}) => {
    const [opened, setOpened] = useState(false);
    const toggleDrop = () => setOpened(!opened);
    document.onclick = () => setOpened(false);
    const currentLang = Strings.getLanguage();
    return (
        <header className="z-10 items-center w-full flex justify-between bg-white top-0">
            <div className={'flex items-center'}>
                <img src={logo} style={{height: '48px'}} alt="talabatey logo"/>
                <img src={zainLogo} className={"mx-1"} style={{height: '30px'}} alt="talabatey logo"/>
            </div>
            <div className="flex">
                <div className={"relative"} onClick={(event) => event.stopPropagation()}>
                    <button
                        onClick={() => toggleDrop()}
                        className="py-2 text-sm bg-zain-primary text-white hover:bg-zain-primary   transition talabatey-outline flex items-center gap-0.5 justify-between   rounded m-2 px-3">
                        <TranslateIcon className="h-5 w-5"/>
                        <span className="mx-auto">
                        {Strings.lang}
                    </span>
                        <ChevronDownIcon className="h-5 w-5"/>
                    </button>
                    <div id='lang-menu'
                         className={`none z-10 absolute shadow transition mt-1 ${Strings.dir}-3    rounded bg-white ${opened ? "" : "scale--0"}`}>
                        <ul className="list-none p-1">
                            {
                                availableLangs.map((lang, index) => <LangItem currentLang={currentLang}
                                                                              setLang={setLang} lang={lang} key={index}
                                                                              toggleDrop={toggleDrop}/>)
                            }
                        </ul>
                    </div>

                </div>
            </div>
        </header>
    );
};
const LangItem = ({setLang, lang, currentLang, toggleDrop}) => {
    if (lang.code === currentLang) {
        return null;
    }
    return <li
        className="my-1 px-10  py-1 text-gray-900 p-1 cursor-pointer hover:bg-gray-200"
        onClick={() => {
            setLang(lang.code)
            toggleDrop()
        }}>
        {lang.displayName}
        <hr/>
    </li>

}


export default Header;
